import React from "react";

// Same outline style as the existing side-view truck icons.
export default function DapTruckIcon({ direction, ...props }) {
  const front = direction === "in";
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
      {front ? (
        <>
          <rect x="5" y="3" width="14" height="15" rx="2" />
          <rect x="7" y="5" width="10" height="5" rx="1" />
          <path d="M5 7H3v4m16-4h2v4M5 15h14m-9-2h4" />
          <path d="M7 13h1m8 0h1" />
        </>
      ) : (
        <>
          <rect x="5" y="2.5" width="14" height="15.5" rx="1" />
          <path d="M12 4.5V15m-2-5v2m4-2v2M4 18h16" />
          <path d="M7 15h2m6 0h2" strokeWidth="2.5" />
        </>
      )}
      <path d="M5 18v3h3v-3m8 0v3h3v-3" />
    </svg>
  );
}
